import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import VerifyCreateUserComponent from "../../components/Auth/VerifyCreateUserComponent";

const VerifyCreateUserPage = () => {
    const navigate = useNavigate();
    const { search } = useLocation();
    let redirect = () => {
        navigate('/dang-nhap.html');
    }

    return <VerifyCreateUserComponent redirect={ () => redirect() } token={ new URLSearchParams(search).get('token') } />

}

export default VerifyCreateUserPage;